export default "__VITE_ASSET__NPmzgUQf__"